// @ts-nocheck
/* eslint-disable */

"use client";
import {
    getAllQuestionaires,
    getNextQuestionAndAnswers,
    postAnswers,
} from "@/lib/chat/ChatActions";
import { useGlobalContext } from "@/lib/globalContext";

import { usePathname, useRouter } from "next/navigation";
import {
    Chat,
    ChatMessages,
    ChatQuestions,
    Question as IQuestion,
    Question,
} from "politicamente-informados-ds";
import { useEffect, useState, useCallback } from "react";

interface Message {
    id: string;
    side: "left" | "right";
    message: string;
    loading: boolean;
}

function convertToQuestions(response: any): Question[] {
    if (!response) return [];
    return response.map((question: any, index: number) => ({
        id: question.id,
        nextNodeId: question.nextNode[0],
        message: question.message,
        number: index + 1,
        onClick: () => "",
    }));
}

const BlockChat = () => {
    const state = useGlobalContext();
    const router = useRouter();
    const thePathname = usePathname().split("/").slice(-1)[0];

    const [answers, setAnswers] = useState<string[]>([]);
    const [chatMessages, setChatMessages] = useState<Message[]>([]);
    const [currentAnswers, setCurrentAnswers] = useState<Question[]>([]);
    const [questionaireId, setQuestionaireId] = useState<string>("");
    const [selectedQuestionaire, setSelectedQuestionaire] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data: allQuestionaires } = (await getAllQuestionaires()) ?? [];
                if (!allQuestionaires) {
                    console.error("Questionnaires not found");
                    return;
                }

                const newSelectedQuestionaire = allQuestionaires?.find(
                    (questionaire: { slug: string }) => thePathname === questionaire.slug
                );

                setSelectedQuestionaire(newSelectedQuestionaire);
                if (!newSelectedQuestionaire) {
                    console.error("Questionnaire not found");
                    return;
                }

                const newQuestionaireId = newSelectedQuestionaire.id;
                const nextMessageID = newSelectedQuestionaire.firstMessage;

                setQuestionaireId(newQuestionaireId);
                setAnswers([nextMessageID]);

                const { data: questionAndAnswers } = await getNextQuestionAndAnswers(
                    newQuestionaireId,
                    nextMessageID
                );

                const { message, id, responses } = questionAndAnswers;
                const newAnswers = convertToQuestions(responses ?? []);

                addMessage(id, message, "left");
                setCurrentAnswers(newAnswers);
            } catch (error) {
                console.error("Error fetching questions:", error);
            }
        };

        fetchData();
    }, []);

    const buildFlowOfQuestionnaire = useCallback((newAnswers: any[]) => {
        const flowOfQuestionnaire = newAnswers.map((answer, index) => {
            return {
                responseOrder: ++index,
                chatNode: answer,
            };
        });

        return { flowOfQuestionnaire };
    }, []);

    const handleQuestionClick = useCallback(
        async (answerId: string, newMessage: string, nextNodeId: string) => {
            try {
                const { data: newQuestionAndAnswers } = await getNextQuestionAndAnswers(
                    questionaireId,
                    nextNodeId
                );

                setAnswers((prev) => [...prev, answerId, nextNodeId]);

                if (!newQuestionAndAnswers?.responses?.length) {
                    const formattedToSubmit = buildFlowOfQuestionnaire([
                        ...answers,
                        answerId,
                        nextNodeId,
                    ]);
                    await postAnswers(questionaireId, formattedToSubmit);
                    router.push(`/chat-tema/${selectedQuestionaire?.slug}/`);
                    return;
                }

                const {
                    message: newQuestion,
                    id: newQuestionId,
                    responses,
                } = newQuestionAndAnswers;
                const newMessages = convertToQuestions(responses);

                setCurrentAnswers(newMessages);
                addMessage(answerId, newMessage, "right");
                addMessage(newQuestionId, newQuestion, "left");
            } catch (error) {
                console.error("Error handling question click:", error);
            }
        },
        [answers, buildFlowOfQuestionnaire, questionaireId]
    );

    const addMessage = useCallback(
        (
            id: string,
            message: string,
            side: "left" | "right",
            loading: boolean = false
        ) => {
            setChatMessages((prev) => [...prev, { id, side, message, loading }]);
        },
        []
    );

    return (
        <Chat>
            <ChatMessages messages={chatMessages} />
            <ChatQuestions
                questions={currentAnswers}
                onQuestionClick={handleQuestionClick}
            />
        </Chat>
    );
};

export default BlockChat;
